"use strict";

import onInitModulesInsScope from "./onInitModulesInScope";

/**
 * Toggles a --stuck modifier on .content-map-lift-list__map-wrap while it is
 * actually pinned by its own `position: sticky`. The wrap's sticky `top`
 * (content-map-lift-list.css) only clears .anchor-nav's own height, not the
 * .main-nav__brand-img logo overhanging further down on top of it — that
 * overlap only happens once the wrap is really stuck under the nav, so the
 * extra clearance (content-map-lift-list.css's --stuck padding-top) has to
 * be conditional rather than baked into `top`/permanent padding, or it would
 * shift the wrap (and waste space) while still in normal flow.
 *
 * Detected by comparing the wrap's live getBoundingClientRect().top against
 * its own resolved `top` CSS value (not a hardcoded px number) — reading the
 * computed style keeps this correct across the project's fluid rem scaling
 * and the mobile breakpoint's different `top` offset, with no separate
 * resize handling needed.
 *
 * Pinned is an approximate EQUALITY check, not "<=": once the sticky
 * containing block (the grid cell) scrolls past, the wrap un-sticks at the
 * bottom and keeps scrolling normally, so rect.top drops well below its
 * sticky `top` value again — "<=" would misread that off-screen state as
 * still stuck.
 */

const STUCK_CLASS = 'content-map-lift-list__map-wrap--stuck';

function isStuck(wrap) {
    let stickyTop = parseFloat(getComputedStyle(wrap).top) || 0;
    return Math.abs(wrap.getBoundingClientRect().top - stickyTop) < 1;
}

export function init() {
    onInitModulesInsScope(function initInScope($scope) {
        let wraps = $scope.find('.content-map-lift-list__map-wrap').toArray();

        if (!wraps.length) {
            return;
        }

        let ticking = false;
        function update() {
            wraps.forEach(function (wrap) {
                wrap.classList.toggle(STUCK_CLASS, isStuck(wrap));
            });
            ticking = false;
        }

        update();

        function onScrollOrResize() {
            if (ticking) {
                return;
            }
            ticking = true;
            requestAnimationFrame(update);
        }

        window.addEventListener('scroll', onScrollOrResize, { passive: true });
        window.addEventListener('resize', onScrollOrResize, { passive: true });
    });
}
